import React from 'react';
import { getSeoData } from '../../utils/helpers';
import ItemCreationForm from '../../components/ItemCreationForm';

const NewItem = () => <ItemCreationForm />;

NewItem.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

export default NewItem;
